import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { i18n } from '@fs/zion-locale'
import NorthAmericaBasePage from './NorthAmericaBasePage'

export default function UnitedStatesPage() {
  usePageView({ page_detail: `NLIHP: United States: ${i18n.language}` })
  return <NorthAmericaBasePage canonicalUrl="https://www.familysearch.org/en/united-states/" />
}
